<div *ngIf="progressBarService.getLoading()">
<mat-progress-bar mode="indeterminate"  [value]="progressBarService.getProgress() | async"></mat-progress-bar>
</div>

<app-page-loader></app-page-loader>
<router-outlet></router-outlet>
